module.exports = __webpack_public_path__ + "img/none.4db15348.png";